import IconCarbonUnknown from '@/shared/icons/IconCarbonUnknown'
import type { MenuIcon, MenuIconProps } from '../types'

interface MenuItemIconProps {
  icon: MenuIcon
  iconProps: MenuIconProps
}

const MenuItemIcon = ({ icon, iconProps }: MenuItemIconProps) =>
  icon ? <>{icon(iconProps)}</> : <IconCarbonUnknown {...iconProps} />

export default MenuItemIcon
